module.exports = __webpack_public_path__ + "img/ud_calculator.fe8fedc1.svg";